export const actionTypes = {
  GET_USER: 'users/getUser',
  LOGIN: 'users/login',
  LOGOUT: 'users/logout',
  JOIN: 'users/join',
  EDIT_PROFILE: 'users/editProfile',
};
